<div *ngIf="signedIn; else showLogin">
    <div ngbDropdown #myDrop="ngbDropdown" display="dynamic" container="body">
        <button class="btn btn-outline-secondary me-2" tabindex="0" id="authDropdown" ngbDropdownAnchor (focus)="myDrop.open()" (click)="$event.stopPropagation(); myDrop.open()" role="button">
            <img src="{{ user.photoURL }}" class="rounded-circle" alt="Profile Photo" width="35" height="35">
        </button>
        <div ngbDropdownMenu aria-labelledby="authDropdown" class="dropdown-menu shadow-sm">
            <div class="px-4">Signed in as {{ user.displayName }}</div>
            <div class="dropdown-divider"></div>
            <a ngbDropdownItem href="#" (click)="logout()">Logout</a>
        </div>
    </div>
</div>

<ng-template #showLogin>
    <button class="btn btn-sm btn-success" (click)="login()">Login with Google</button>
</ng-template>